import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginateQuery, PaginatorModel } from 'symbols';
import { TelegramChatMessageModel, TelegramChatModel } from '../symbols';
import { VideoMeta } from '../video-meta';

@Injectable()
export class TelegramChatService {
  private readonly api = '/api/telegram-chat';

  constructor(private http: HttpClient) {
  }

  getChatListLazy(url: string): Observable<PaginatorModel<TelegramChatModel>> {
    return this.http.get<PaginatorModel<TelegramChatModel>>(url);
  }

  public getChatList(filter?: PaginateQuery<{ search: string }>): Observable<PaginatorModel<TelegramChatModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      search: filter?.filter.search
    };

    return this.http.get<PaginatorModel<TelegramChatModel>>(`${this.api}/chat-list/`, { params });
  }

  public getUnreadMessagesCount(): Observable<number> {
    return this.http.get<number>(`${this.api}/count-unread-chats`);
  }

  public getMessagesByChatId(chatId: string, filter?: PaginateQuery<{
    search: string
  }>): Observable<PaginatorModel<TelegramChatMessageModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      search: filter?.filter.search
    };

    return this.http.get<PaginatorModel<TelegramChatMessageModel>>(`${this.api}/messages/${chatId}`, { params });
  }

  public getChatMessageListLazy(url: string): Observable<PaginatorModel<TelegramChatMessageModel>> {
    return this.http.get<PaginatorModel<TelegramChatMessageModel>>(url);
  }

  public readMessageByChatId(chatId: string): Observable<void> {
    return this.http.patch<void>(`${this.api}/read-message/${chatId}`, {});
  }

  public sendMessageToChat(chatId: number, message: string): Observable<void> {
    return this.http.post<void>(`${this.api}/send-message/`, { message, chatId });
  }

  // Фото або відео від менеджера; події з прогресом завантаження (відео може бути великим)
  public sendMediaToChat(chatId: number, file: File, caption?: string, videoMeta?: VideoMeta | null): Observable<HttpEvent<void>> {
    const body = buildMediaFormData(chatId, file, caption, videoMeta);
    return this.http.post<void>(`${this.api}/send-media`, body, { reportProgress: true, observe: 'events' });
  }
}

// Тіло запиту відправки фото/відео; для відео — розміри й тривалість, щоб Telegram не розтягував його
export function buildMediaFormData(chatId: number, file: File, caption?: string, videoMeta?: VideoMeta | null): FormData {
  const body = new FormData();
  body.append('chatId', String(chatId));
  body.append('caption', caption || '');
  if (videoMeta) {
    body.append('width', String(videoMeta.width));
    body.append('height', String(videoMeta.height));
    body.append('duration', String(videoMeta.duration));
  }
  body.append('file', file, file.name);
  return body;
}

